import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { RPAsRelatorioPendenciasComponent } from './rpas-relatorio-pendencias.component';

@NgModule({
  declarations: [RPAsRelatorioPendenciasComponent],
  exports: [RPAsRelatorioPendenciasComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    PoModule,
    FormsModule
  ]
})
export class RpasRelatorioPendenciasModule {}
